export const EventWizardStyle = { 
	backgroundColor:'#fff',
	borderRadius : '5px',
	padding : '1em',
	margin : '0em'
}
export const EventWizardState = { 
	doneItem: { background: "#4FFF00" },
	activeItem: { background:"#1A6EFF" } 
}
export const EventWizardPanel = {
	maxHeight:'auto', //1550
	marginTop:'-18px', 
	marginBottom:'0', 
	paddingRight:'10px' 
}



// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Wizard/style.js